import type { DocumentType } from '../graphql/generated/gql';
import { gql } from '../graphql/generated/gql';

const NOTIFICATION_FRAGMENT = gql(`
  # eslint-disable-next-line @graphql-eslint/require-selections
  fragment getNotificationPostId_notification on Notification {
    ... on CommentNotification {
      # eslint-disable-next-line @graphql-eslint/require-selections
      comment {
        # eslint-disable-next-line @graphql-eslint/require-selections
        thread {
          post {
            id
          }
        }
      }
    }
    ... on HistoryNotification {
      # eslint-disable-next-line @graphql-eslint/require-selections
      history {
        post {
          id
        }
      }
    }
    ... on PostNotification {
      post {
        id
      }
    }
    ... on ReactionNotification {
      # eslint-disable-next-line @graphql-eslint/require-selections
      reaction {
        # eslint-disable-next-line @graphql-eslint/require-selections
        thread {
          post {
            id
          }
        }
      }
    }
  }
`);

const getNotificationPostId = (
  notification: DocumentType<typeof NOTIFICATION_FRAGMENT>,
): string | null => {
  if ('comment' in notification) {
    return notification.comment?.thread.post.id ?? null;
  }
  if ('history' in notification) {
    return notification.history?.post.id ?? null;
  }
  if ('post' in notification) {
    return notification.post?.id ?? null;
  }
  if ('reaction' in notification) {
    return notification.reaction?.thread.post.id ?? null;
  }

  return null;
};

export default getNotificationPostId;
